import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '@app/shared/button/button.component';
import { MessageComponent, TypeMessage } from '@app/shared/message/message.component';
import { RequestCodeService } from '@modules/sign-in/components/sign-up/components/send-code/request-code.service';
import { SendCodePayload } from '@modules/sign-in/components/sign-up/components/send-code/send-code.model';
import { SmsCodeService } from '@modules/sign-in/components/sign-up/components/send-code/sms-code.service';
import { NgxMaskModule } from 'ngx-mask';
import { finalize, interval, map, Observable, Subject, switchMap, take, tap } from 'rxjs';
import { TypeStep } from '../sign-up.component';

@Component({
  selector: 'app-enter-code',
  templateUrl: './enter-code.component.html',
  styleUrls: ['./enter-code.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, FormsModule, ButtonComponent, MessageComponent, NgxMaskModule],
})
export class EnterCodeComponent implements OnInit {
  @Input() phone: string;
  @Input() isResetPassword = false;
  @Output() changeStep = new EventEmitter<TypeStep>();
  @Output() putToken = new EventEmitter<string>();

  code: string = null;
  codeForm: FormGroup;
  errorObject: { isError: boolean; type: TypeMessage; message: string } = {
    isError: false,
    type: 'error',
    message: 'Неверный код',
  };
  isSendCode = false;
  public codeResendInFly = false;

  public resendCodeAfterSubject = new Subject<void>();
  public resendCodeAfter$: Observable<number> = this.resendCodeAfterSubject.asObservable().pipe(switchMap(() => this.#resendAfterTimer()));

  public requestCodeOperation$: Observable<any>;

  #resendCodeRequestSubject = new Subject<SendCodePayload>();
  public resendCodeRequest$: Observable<SendCodePayload> = this.#resendCodeRequestSubject.asObservable().pipe(
    tap(() => (this.codeResendInFly = true)),
    tap(() => this._requestCodeService.requestCode(this.phone)),
    tap(() => this.resendCodeAfterSubject.next()),
  );
  constructor(
    private _requestCodeService: RequestCodeService,
    private smsCodeService: SmsCodeService,
  ) {}
  ngOnInit(): void {
    this.codeForm = new FormGroup({
      login: new FormControl(this.phone, [Validators.required]),
      code: new FormControl<string>(null, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]),
    });

    this.codeForm.get('code').valueChanges.subscribe(() => {
      if (this.errorObject.isError) {
        this.errorObject.isError = false;
      }
    });
    this._requestCodeService.requestCode(this.phone);
    this.requestCodeOperation$ = this._requestCodeService.requestCode$;
    this.initValidateSMSCodeOperation();
  }

  initValidateSMSCodeOperation(): void {
    // this.validateSMSCodeOperationInFly$ = this.smsCodeService.sendCodeOperationInFly$;
    this.smsCodeService.sendCodeOperation$
      .pipe(
        tap(({ ok, token, errorCode }) => (ok ? this.changeNextStepAndSendToken(token) : '')),
        map(() => void 0),
      )
      .subscribe();
  }

  sendCode() {
    this.smsCodeService.sendCode({ phoneNumber: this.phone, code: this.codeForm.get('code').value });
  }

  changeNextStepAndSendToken(token: string) {
    this.putToken.emit(token);
    if (this.isResetPassword) {
      this.changeStep.emit('createNewPassword');
    } else {
      this.changeStep.emit('registration');
    }
  }

  stepBack() {
    this.changeStep.emit('login');
  }

  public resendCode(): void {
    this.#resendCodeRequestSubject.next(null);
  }

  #resendAfterTimer() {
    return interval(1000).pipe(
      take(120),
      map((v) => 120 - (v + 1)),
      finalize(() => (this.codeResendInFly = false)),
    );
  }
}
